// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M4 0H20V3H4V0Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M4 5H20V7.4141L17 10.4141V23.9999H7V10.4141L4 7.4141V5ZM13.0039 10H11V12.0039H13.0039V10Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-flashlight-filled')
export default class FlashlightFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'flashlight-filled',
    }
  }
}
